module.exports = __webpack_public_path__ + "img/bnr-sky-s.3b69f181.jpg";